export const headerList = [
  {
    label: 'Symbol',
    field: 'symbol',
  },
  {
    label: 'Side',
    field: 'sideEnum'
  },
  {
    label: 'Qty.',
    field: 'quantity'
  },
  {
    label: 'Fill',
    field: 'avg_fill_price' // ?
  },
  {
    label: 'Bid',
    field: 'bid'
  },
  {
    label: 'Ask',
    field: 'ask'
  },
  {
    label: 'uPnL',
    field: 'uPnlAtBidAsk'
  },
  {
    label: 'rPnL',
    field: 'realizedPnl'
  },
  {
    label: '%pnl',
    field: 'uPnlAtBidAsk'
  },
  {
    label: 'Date',
    field: 'date_acquired'
  },
  {
    label: 'Cost',
    field: 'cost_basis'
  },
  // {
  //   label: 'Account',
  //   field: 'accountId'
  // },
  {
    label: 'Broker',
    field: 'brokerage'
  },
];
